import React from 'react';

export default function Moon() {
  return <img src="/milanbeats/Images/moon.png" className="moon"/>;
}
